import { LegalBasis } from '@dreryk/egabinet-patient-frontend-api';

import { FormContextValues } from '@dreryk/react-common';
import { AutoLayout } from '@dreryk/react-components';

import { EntitlementStatementCreateFormBean } from '../../../entitlementStatements/create/form/EntitlementStatementCreateForm';
import { LegalBasisField } from '../LegalBasisField';

type EntitlementStatementSectionProps = Pick<FormContextValues<EntitlementStatementCreateFormBean>, 'register'> & {
   readonly legalBasis: LegalBasis[];
};

export const EntitlementStatementSection = ({
   register,
   legalBasis,
}: EntitlementStatementSectionProps): JSX.Element => {
   return (
      <>
         <AutoLayout
            as={LegalBasisField}
            name={'legalBasis'}
            register={register}
            legalBasis={legalBasis}
            required
            $horizontalResizing={750}
         />
      </>
   );
};
